export const SET_REGISTROS_POR_PAGINA = 'PAGINATION/SET_REGISTROS_POR_PAGINA'
